import { Fade, Reveal } from 'react-awesome-reveal';
import classnames from 'classnames';
import { animateScroll } from 'react-scroll';
import fadeInLeft from 'components/animations/fadeInLeft';
import fadeInRight from 'components/animations/fadeInRight';
import lang from 'constants/lang';
import translations from 'constants/home';
import styles from './Body.module.scss';

function Body() {
  return (
    <section className={ styles.container }>
      <div className={ styles.body1 }>
        <h1>META-PARADE</h1>
        <p>
          { translations.body1a }<br /><br />
          { translations.body1b }<br /><br />
          { translations.body1c }<br /><br />
          { translations.body1pt1 }<br />
          { translations.body1pt2 }<br />
          { translations.body1pt3 }<br />
          { translations.body1pt4 }
        </p>
      </div>

      <div className={ styles.body2 }>
        <video src={ `${process.env.PUBLIC_URL}/videos/metaparade.mp4` } autoPlay loop muted controls playsInline preload="auto" className={ styles.video } />
        <Fade duration={ 2000 } delay={ 200 } triggerOnce>
          <p>
            { translations.body2 }
          </p>
        </Fade>
      </div>

      <div className={ styles.body3 }>
        <div className={ styles.imgWrapper }>
          <div className={ styles.img }>
            <img src={ `${process.env.PUBLIC_URL}/images/persona2.jpg` } alt="" />
          </div>
          <div className={ styles.obj }>
            <img src={ `${process.env.PUBLIC_URL}/images/obj1.png` } alt="" />
          </div>
        </div>
        <p className={ classnames(styles.bodyText, styles[lang]) }>
          <Reveal duration={ 2000 } delay={ 200 } keyframes={ fadeInRight } triggerOnce>
            <div>
              <img src={ `${process.env.PUBLIC_URL}/images/icon2.svg` } alt=""  className={ styles.icon } />
              <br />
              <span className={ styles.subtitle }>{ translations.subtitle3 }</span>
              <br /><br />
              { translations.body3 }
            </div>
          </Reveal>
        </p>
        <div className={ styles.clearfix } />
      </div>

      <div className={ styles.body4 }>
        <Fade duration={ 2000 } delay={ 200 } triggerOnce>
          <div className={ styles.imgWrapper }>
            <div className={ styles.img }>
              <img src={ `${process.env.PUBLIC_URL}/images/persona3.jpg` } alt="" />
            </div>
            <div className={ styles.obj }>
              <img src={ `${process.env.PUBLIC_URL}/images/obj2.png` } alt="" />
            </div>
          </div>
        </Fade>
        <p className={ classnames(styles.bodyText, styles[lang]) }>
          <Reveal duration={ 2000 } delay={ 200 } keyframes={ fadeInRight } triggerOnce>
            <div>
              <img src={ `${process.env.PUBLIC_URL}/images/icon3.svg` } alt=""  className={ styles.icon } />
              <br />
              <span className={ styles.subtitle }>{ translations.subtitle4 }</span>
              <br /><br />
              { translations.body4 }
            </div>
          </Reveal>
        </p>
        <div className={ styles.clearfix } />
      </div>

      <div className={ styles.body5 }>
        <Fade duration={ 2000 } delay={ 200 } triggerOnce>
          <div className={ styles.imgWrapper }>
            <div className={ styles.img }>
              <img src={ `${process.env.PUBLIC_URL}/images/persona4.jpg` } alt="" />
            </div>
            <div className={ styles.obj }>
              <img src={ `${process.env.PUBLIC_URL}/images/obj3.png` } alt="" />
            </div>
          </div>
        </Fade>
        <p className={ styles.bodyText }>
          <Reveal duration={ 2000 } delay={ 200 } keyframes={ fadeInLeft } triggerOnce>
            <div>
              <img src={ `${process.env.PUBLIC_URL}/images/icon4.svg` } alt=""  className={ styles.icon } />
              <br />
              <span className={ styles.subtitle }>{ translations.subtitle5 }</span>
              <br /><br />
              { translations.body5 }
            </div>
          </Reveal>
        </p>
        <div className={ styles.clearfix } />
      </div>

      <div className={ styles.body6 }>
        <Fade duration={ 2000 } delay={ 200 } triggerOnce>
          <div className={ styles.imgWrapper }>
            <div className={ styles.img }>
              <img src={ `${process.env.PUBLIC_URL}/images/persona5.jpg` } alt="" />
            </div>
            <div className={ styles.obj }>
              <img src={ `${process.env.PUBLIC_URL}/images/obj4.png` } alt="" />
            </div>
          </div>
        </Fade>
        <p className={ classnames(styles.bodyText, styles[lang]) }>
          <Reveal duration={ 2000 } delay={ 200 } keyframes={ fadeInLeft } triggerOnce>
            <div>
              <img src={ `${process.env.PUBLIC_URL}/images/icon5.svg` } alt=""  className={ styles.icon } />
              <br />
              <span className={ styles.subtitle }>{ translations.subtitle6 }</span>
              <br /><br />
              { translations.body6 }
            </div>
          </Reveal>
        </p>
        <div className={ styles.clearfix } />
      </div>

      <div className={ styles.body7 }>
        <Fade duration={ 2000 } delay={ 200 } triggerOnce>
          <p>
            { translations.body7a }<br /><br />
            { translations.body7b }
          </p>
        </Fade>
        <Fade duration={ 2000 } delay={ 200 } triggerOnce>
          <div className={ styles.logo }>
            <img src={ `${process.env.PUBLIC_URL}/images/hkstp.svg` } alt="HKSTP" />
          </div>
        </Fade>
        <Fade duration={ 2000 } delay={ 200 } direction="up" triggerOnce>
          <div className={ styles.top } onClick={ () => animateScroll.scrollToTop() }>
            { translations.backToTop }<br />
            <img src={ `${process.env.PUBLIC_URL}/images/arrow-top.svg` } alt="" />
          </div>
        </Fade>
      </div>
    </section>
  );
}

export default Body;